import { createSelector } from "reselect";

export const isAuthenticated = (state) => {
    if (state.auth.token) return true;
    return false;
};

export const getProfile = (state) => (state.auth.userInfo);